module.exports = __webpack_public_path__ + "img/facs.fc29523a.jpg";